import { NavLink } from "react-router-dom";
import BrandLogo from "../../components/common/BrandLogo";

const navBrandClasses = "h-8 w-auto";

const NavBrand = ({ to }) => (
    <NavLink to={to} className="mr-4">
        <BrandLogo className={navBrandClasses} />
    </NavLink>
)

export default NavBrand;
